export default __webpack_public_path__ + "static/preview-9998da168a6a049fd44fb7147050740a.png";